import api from "./api";

const qs = (p) =>
  new URLSearchParams(
    Object.entries(p).filter(([, v]) => v !== "" && v !== undefined && v !== null)
  );

const inventarioService = {
  // Config contábil
  getConfig: (idCondominio) =>
    api("GET", `/inventario/config?${qs({ idCondominio })}`),
  salvarConfig: (data) => api("POST", "/inventario/config", data),

  // Picker de itens (com saldo atual)
  itensPicker: (p = {}) =>
    api("GET", `/inventario/itens-picker?${qs(p)}`),

  // CRUD inventários
  listar: (p = {}) => api("GET", `/inventario?${qs(p)}`),
  buscar: (id) => api("GET", `/inventario/${id}`),
  criar: (data) => api("POST", "/inventario", data),
  atualizar: (id, data) => api("PUT", `/inventario/${id}`, data),

  // Linhas
  salvarItens: (id, itens) => api("POST", `/inventario/${id}/itens`, { itens }),

  // Ações
  aplicar: (id, data = {}) => api("POST", `/inventario/${id}/aplicar`, data),
  cancelar: (id) => api("POST", `/inventario/${id}/cancelar`),
};

export default inventarioService;
